import { Component, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FileUploaderService } from '../../../services/file-uploader';

@Component({
  selector: 'ems-floating-file-button',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './floating-file-button.html',
  styleUrls: ['./floating-file-button.scss'],
})
export class FloatingFileButtonComponent {
  fileUploaderService: FileUploaderService = inject(FileUploaderService);
}
